import { PreferenceSection } from "../../../utils/enums";
import NotificationSettingsView from "./Views/NotificationSettingsView";
import WorkingHoursSettingsView from "./Views/WorkingHoursSettingsView";

interface PreferencesContentProps {
  selectedSection: string;
};

const PreferencesContent = ({ selectedSection }: PreferencesContentProps) => {
  const renderContent = () => {
    switch (selectedSection) {
      case PreferenceSection.Notifications:
        return <NotificationSettingsView />;
      case PreferenceSection.WorkingHours:
        return <WorkingHoursSettingsView />;
    }
  };

  return <>
    {renderContent()}
  </>;
};

export default PreferencesContent;